module.exports = __webpack_public_path__ + "static/preview3-7c71130e4e4754e294b75a86c0ad3c9d.jpg";